import React from 'react';
import {
  FaTv,
  FaWifi,
  FaCar,
  FaTaxi,
  FaGift,
  FaConciergeBell,
  FaSnowflake,
  FaUtensils
} from "react-icons/fa";


const AmenitiesSection = () => {
   const amenities = [
    { icon: <FaTv />, title: "TV Enabled", description: "Smart LED TV" },
    { icon: <FaWifi />, title: "Free Wi-Fi", description: "High-speed internet" },
    { icon: <FaCar />, title: "Local Tour", description: "Guided tours" },
    { icon: <FaTaxi />, title: "Cab Rentals", description: "24/7 car service" },
    { icon: <FaGift />, title: "Complementary", description: "Welcome amenities" },
    { icon: <FaConciergeBell />, title: "Room Service", description: "24-hour dining" },
    { icon: <FaSnowflake />, title: "24X7 AC", description: "Climate control" },
    { icon: <FaUtensils />, title: "Veg Restaurant", description: "Pure vegetarian" }
  ];

  return (
    <div className="py-12 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        
        {/* Header - Compact */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Hotel <span className="text-amber-700">Prakash Palace</span>
          </h1>
          <div className="w-16 h-1 bg-gradient-to-r from-amber-500 to-orange-500 mx-auto rounded-full mb-3"></div>
          <p className="text-gray-600 text-sm">Premium amenities for a luxurious stay</p>
        </div>

        <div className="grid lg:grid-cols-5 gap-6 items-start">
          
          {/* Left Image - Compact */}
          <div className="lg:col-span-2">
            <div className="relative rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://images.oyoroomscdn.com/uploads/hotel_image/91361/medium/eaa0891bebd0ff76.jpg" 
                alt="Luxury Room"
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-3 right-3 bg-gradient-to-r from-amber-600 to-orange-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold">
                ⭐ 4.9/5
              </div>
            </div>
            
            {/* Quick Info below image */}
            <div className="mt-4 grid grid-cols-2 gap-3">
              <div className="bg-amber-50 p-3 rounded-lg text-center">
                <div className="text-amber-700 font-bold text-sm">Best Location</div>
                <div className="text-gray-600 text-xs">Near Assi Ghat</div>
              </div>
              <div className="bg-orange-50 p-3 rounded-lg text-center">
                <div className="text-orange-700 font-bold text-sm">24/7 Support</div>
                <div className="text-gray-600 text-xs">Always Available</div>
              </div>
            </div>
          </div>

          {/* Right Amenities - Compact Grid */}
          <div className="lg:col-span-3">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {amenities.map((amenity, index) => (
                <div 
                  key={index} 
                  className="group relative bg-white border border-gray-200 rounded-lg p-4 hover:border-amber-300 hover:shadow-md transition-all duration-200"
                >
                  {/* Icon */}
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-100 to-orange-100 rounded-xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform">
                    <span className="text-xl">{amenity.icon}</span>
                  </div>
                  
                  {/* Content */}
                  <div className="text-center">
                    <h3 className="font-bold text-gray-900 text-sm mb-1">{amenity.title}</h3>
                    <p className="text-gray-600 text-xs">{amenity.description}</p>
                  </div>
                  
                  {/* Hover Indicator */}
                  <div className="absolute top-2 right-2 w-2 h-2 bg-amber-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </div>
              ))}
            </div>
            
            {/* Stats Row */}
            <div className="mt-6 grid grid-cols-3 gap-3">
              <div className="bg-gray-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-amber-700">100%</div>
                <div className="text-gray-600 text-xs">Clean Rooms</div>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-amber-700">24/7</div>
                <div className="text-gray-600 text-xs">Service</div>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-amber-700">50+</div>
                <div className="text-gray-600 text-xs">Amenities</div>
              </div>
            </div>
          </div>
        </div>

        {/* Compact CTA */}
        <div className="mt-8 pt-6 border-t border-gray-100">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <h4 className="font-bold text-gray-900 text-sm">Ready to experience luxury?</h4>
              <p className="text-gray-600 text-xs">All amenities included in your stay</p>
            </div>
            <div className="flex gap-3">
              <button className="px-5 py-2 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-lg text-sm font-semibold hover:shadow-sm">
                Book Now
              </button>
              <button className="px-5 py-2 bg-white border border-gray-300 text-gray-800 rounded-lg text-sm font-semibold hover:bg-gray-50">
                View Rooms
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AmenitiesSection;